{
  "chatAlsoDriverQuestion": "Também conduz os veículos da sua frota?",
  "chatAlsoDriverHint": "Pode completar o seu perfil de condutor depois do registo.",
  "chatAlsoDriverYes": "Sim, também conduzo",
  "chatAlsoDriverNo": "Não, apenas faço a gestão da frota",
  "chatEmailQuestion": "Qual é o seu email?",
  "chatEmailHint": "Vai usá-lo para entrar na sua conta.",
  "chatPasswordQuestion": "Crie uma palavra-passe",
  "chatPasswordHint": "Pelo menos 8 caracteres.",
  "chatNameQuestion": "Como se chama?",
  "chatPhoneQuestion": "Qual é o seu telemóvel?",
  "chatPhoneHint": "Para contactos sobre a sua frota.",
  "chatOwnerTypeQuestion": "Como opera a sua atividade?",
  "chatOwnerTypeHint": "Escolha a opção que corresponde à sua situação.",
  "chatNifQuestion": "Qual é o seu NIF?",
  "chatAddressQuestion": "Qual é a sua morada?",
  "chatCmtvdeQuestion": "Qual é o seu CMTVDE?",
  "chatDobQuestion": "Qual é a sua data de nascimento?",
  "chatDobHint": "Use o formato DD/MM/AAAA.",
  "chatCompanyNameQuestion": "Qual é o nome da empresa?",
  "chatNipcQuestion": "Qual é o NIPC da empresa?",
  "chatLicenseQuestion": "Qual é a licença de operador?",
  "chatLicenseHint": "Formato: número/ano — por exemplo 12345/2024.",
  "chatContinue": "Continuar",
  "chatProgress": "{{current}}/{{total}}",
  "ownerTypeIndividual": "Recibo verde / NIF",
  "ownerTypeCompany": "Empresa / NIPC",
  "nifLabel": "NIF",
  "nifPlaceholder": "NIF",
  "nifRequired": "O NIF é obrigatório.",
  "nifInvalidLength": "NIF deve ter 9 dígitos",
  "nifInvalid": "NIF inválido",
  "addressPlaceholder": "Morada",
  "addressRequired": "A morada é obrigatória.",
  "cmtvdePlaceholder": "Número da CMTVDE",
  "cmtvdeRequired": "O CMTVDE é obrigatório.",
  "cmtvdeInvalid": "Formato inválido (N+/YYYY).",
  "dobPlaceholder": "Data de nascimento",
  "dateOfBirthRequired": "A data de nascimento é obrigatória.",
  "registerTitle": "Registar",
  "chooseRolePrompt": "Escolha como deseja registar-se: Condutor ou Proprietário de Frota. Se for ambos, registe-se como Proprietário.",
  "driverButton": "Condutor",
  "ownerButton": "Proprietário de Frota",
  "registerDriverTitle": "Registo de Condutor",
  "registerOwnerTitle": "Registar como Proprietário de Frota",
  "loginInformation": "Informação de Login",
  "identification": "Identificação",
  "driverDetails": "Detalhes do Condutor",
  "companyInformation": "Informação da Empresa",
  "next": "Seguinte",
  "back": "Voltar",
  "submitButton": "Enviar",
  "registrationSuccessTitle": "Registado com sucesso!",
  "registrationSuccessMessage": "Confirme o seu email para completar o registo.",
  "okButton": "OK",
  "ownerButtonDisabled": "Registo de Proprietário Desativado",
  "driverButtonDisabled": "Registo de Condutor Desativado",
  "loadingRegistrationStatus": "A carregar opções de registo...",
  "continue": "Continuar",
  "employmentTitle": "Informação de Emprego",
  "loadingEmploymentInfo": "A carregar informação de emprego...",
  "employmentDataFound": "Encontramos a sua informação de emprego:",
  "edit": "Editar",
  "retry": "Tentar Novamente",
  "employmentFormIntro": "Por favor, forneça a sua informação de emprego:",
  "companyName": "Nome da Empresa",
  "companyNameRequired": "O nome da empresa é obrigatório.",
  "companyNipc": "NIF/NIPC da Empresa",
  "nipcError": "O NIF/NIPC deve conter 9 dígitos",
  "nipcInvalid": "NIPC inválido",
  "companyEmail": "Email da Empresa",
  "companyPhone": "Telefone da Empresa",
  "companyEmailOptional": "Email da empresa (opcional)",
  "companyPhoneOptional": "Telefone da empresa (opcional)",
  "companyContactOr": "OU",
  "permissionsTitle": "Permissões da Aplicação",
  "permissionsDescription": "Para fornecer a melhor experiência, precisamos das seguintes permissões:",
  "notificationsPermissionTitle": "Notificações",
  "notificationsPermissionDescription": "Para receber alertas e informações importantes",
  "locationForegroundPermissionTitle": "Localização (Primeiro Plano)",
  "locationForegroundPermissionDescription": "Para mostrar a sua localização atual no mapa",
  "locationBackgroundPermissionTitle": "Localização (Segundo Plano)",
  "locationBackgroundPermissionDescription": "Para continuar a rastrear mesmo quando a aplicação está fechada",
  "locationBackgroundPermissionImportant": "Importante: Para receber notificações quando estiver parado no mesmo local durante algum tempo, precisa de selecionar 'Permitir sempre' nas definições de localização do seu dispositivo.",
  "permissionsFinish": "Concluir",
  "duplicateIdentityTitle": "Já está registado",
  "duplicateIdentityMessage": "Este dado já está registado numa conta existente. Inicie sessão com essa conta em vez de criar um novo registo.",
  "goToLogin": "Entrar na conta",
  "recoverAccount": "Recuperar acesso",
  "requestAuthorizedClaim": "Pedir ajuda ao suporte",
  "supportRequestTitle": "Pedir ajuda ao suporte",
  "supportRequestIntro": "Indique um contacto e explique brevemente como podemos ajudar. A equipa de suporte poderá pedir documentos mais tarde através de um canal autenticado.",
  "supportRequestEmail": "Email",
  "supportRequestPhone": "Telemóvel",
  "supportRequestDescription": "Como podemos ajudar?",
  "supportRequestSubmit": "Enviar pedido",
  "supportRequestReceived": "Recebemos o seu pedido. A equipa de suporte irá contactar-te.",
  "supportRequestFailed": "Não foi possível enviar o pedido. Tente novamente.",
  "supportRequestPhoneRequired": "Indique o seu telemóvel.",
  "supportRequestEmailRequired": "Indique o seu email.",
  "supportRequestDescriptionRequired": "Descreva brevemente o pedido.",
  "supportAccountTitle": "Criar a sua conta de suporte",
  "supportAccountIntro": "Crie e confirme a sua conta para a equipa continuar a analisar o pedido. Não precisa de indicar o NIPC novamente.",
  "supportAccountName": "Nome completo",
  "supportAccountPassword": "Palavra-passe",
  "supportAccountRequired": "Preencha todos os campos para continuar.",
  "supportAccountSubmit": "Criar conta",
  "supportAccountCreated": "Conta criada. Confirme o email para a equipa de suporte continuar.",
  "supportAccountFailed": "Não foi possível criar a conta. Tente novamente.",
  "cancel": "Cancelar",
  "chatGreeting": "Olá! 👋 Bem-vindo ao AllDrivers.",
  "chatChoiceQuestion": "Para começar: gere uma frota ou conduz?",
  "chatChoiceHint": "Leva menos de 2 minutos — prometido.",
  "chatChoiceOwner": "Tenho uma frota 🚗",
  "chatChoiceOwnerAnswer": "Tenho uma frota 🚗",
  "chatChoiceDriver": "Sou motorista 🧑‍✈️",
  "chatChoiceDriverAnswer": "Sou motorista 🧑‍✈️",
  "chatOwnerIntro": "Ótimo! Vamos criar a sua conta de frota. 🚗",
  "chatAccountCreatedBridge": "Conta criada! 🎉 Agora vamos preparar a sua frota.",
  "chatDriverIntro": "Vamos criar a sua conta de condutor. 🧑‍✈️",
  "chatProfileRecoveryIntro": "Vamos completar os dados da sua conta. 🧑‍✈️",
  "chatDriverPhoneHint": "Para contactos sobre a sua atividade.",
  "chatPayerQuestion": "Quem paga a sua licença?",
  "chatPayerHint": "Pode mudar isto mais tarde.",
  "chatCompanyQuestion": "A que empresa está associado?",
  "chatCompanyHint": "Procuramos a empresa pelo NIPC. Se a encontrarmos, não precisa de indicar contacto.",
  "companyLookupFoundTitle": "Encontrámos esta empresa",
  "companyLookupFoundMessage": "{{name}} (NIPC {{nipc}}). É esta a empresa para a qual trabalha?",
  "companyLookupConfirmYes": "Sim, é a minha empresa",
  "companyLookupConfirmNo": "Não, vou corrigir",
  "companyLookupConfirmRequired": "Confirme se é esta a empresa para a qual trabalha.",
  "companyLookupInviteMismatch": "O NIPC não corresponde à empresa do convite. Corrija antes de continuar.",
  "companyLookupConfirmedHint": "Empresa confirmada. Pode continuar.",
  "companyLookupLoading": "A verificar empresa…",
  "companyLookupFailed": "Não foi possível verificar a empresa.",
  "companyContactHintUnknown": "Não encontrámos esta empresa. Preencha apenas um dos dois campos: email ou telefone.",
  "companyContactRequired": "Indique um email ou telefone da empresa — não conseguimos encontrar esta empresa.",
  "payerRequired": "Escolha quem paga.",
  "payerCompany": "A minha empresa paga",
  "payerSelf": "Eu pago a minha licença",
  "chatProductQuestion": "O que quer usar?",
  "chatProductHint": "Escolha um; outras combinações ficam no painel.",
  "productRequired": "Escolha um produto.",
  "productOptionHours": "Registo de horas",
  "productOptionGps": "GPS",
  "productOptionCombo": "Horas + GPS",
  "companyContactRequired": "Indique um email ou telefone da empresa.",
  "invitationFoundTitle": "Encontrámos um convite",
  "invitationFoundMessage": "{{company}} já convidou este email. Quer aceitar o convite?",
  "invitationFoundDecline": "Continuar sem convite",
  "invitationFoundAccept": "Aceitar convite",
  "invitationLinkRequiredTitle": "Use o link do convite",
  "invitationLinkRequiredMessage": "Existe um convite para este email. Abra o link recebido para continuar; não mostramos os detalhes do convite aqui.",
  "outcomeC4Title": "Ainda não encontrámos essa empresa",
  "outcomeC4Message": "{{company}} ainda não está no AllDrivers. Já enviámos um convite ao contacto que indicou — também pode partilhar o link diretamente.",
  "outcomeC3Title": "A aguardar aprovação",
  "outcomeC3Message": "{{company}} já está no AllDrivers — avisámos o gestor. Assim que aprovar, o seu acesso fica ativo.",
  "outcomeActiveTitle": "Está tudo pronto",
  "outcomeActiveMessage": "O seu vínculo com {{company}} está ativo. Já pode começar a trabalhar.",
  "outcomePendingInviteTitle": "A aguardar ativação",
  "outcomePendingInviteMessage": "A tua conta está a aguardar ativação.",
  "outcomePendingLicenseTitle": "A aguardar ativação",
  "outcomePendingLicenseMessage": "A tua conta está a aguardar ativação.",
  "outcomeContactTitle": "Ainda não encontrámos essa empresa",
  "outcomeContactMessage": "{{company}} ainda não está no AllDrivers. Guardámos o seu contacto e a nossa equipa vai falar com a empresa — também pode partilhar o link diretamente com o gestor.",
  "outcomeFailedTitle": "Não foi possível concluir",
  "outcomeFailedMessage": "Algo correu mal ao concluir o seu registo com {{company}}. Tente novamente ou contacte o suporte.",
  "outcomeSelfPayHint": "Quando a empresa aprovar, volte a Definições → Pagar a minha licença para ativar o pagamento próprio.",
  "outcomeShareCta": "Partilhar com o gestor",
  "outcomeContinue": "Ir para o Dashboard",
  "outcomeContactContinue": "Acompanhar ativação",
  "companyContactPendingTitle": "A aguardar a empresa",
  "companyContactPendingBody": "A empresa ainda não ativou o seu acesso. Pode aguardar pela empresa ou pagar a sua própria licença para avançar já.",
  "companyContactPendingSelfPayTitle": "Avançar sem esperar",
  "companyContactPendingSelfPayBody": "Se escolheu a empresa por engano ou já não quer esperar, mude para pagamento próprio. Só paga depois de escolher e confirmar o plano.",
  "companyContactPendingSelfPay": "Pagar a minha própria licença",
  "companyContactPendingSelfPayError": "Não foi possível mudar para pagamento próprio. Tente novamente.",
  "companyContactPendingWaitTitle": "Continuar a aguardar",
  "companyContactPendingWaitBody": "Partilhe este link com o gestor para acelerar a ativação.",
  "companyContactPendingShare": "Partilhar link com o gestor",
  "companyContactPendingLogout": "Sair",
  "captchaError": "Não foi possível confirmar que é uma pessoa. Tente novamente.",
  "captchaFailed": "A verificação falhou. Tente novamente.",
  "appStoresTitle": "Instale a app AllDrivers",
  "appStoresMessage": "Instale a app e entre com a mesma conta AllDrivers. Não crie outra conta. Se ainda não confirmou o email, confirme-o primeiro através da mensagem de registo.",
  "downloadApp": "Descarregar a app",
  "appStoreOpenError": "Não foi possível abrir a loja. Tente novamente no botão da loja.",
  "appStoreTrademarks": "Apple, o logótipo Apple e App Store são marcas da Apple Inc. Google Play e o logótipo Google Play são marcas da Google LLC.",
  "appStoreAndroid": "Google Play (Android)",
  "appStoreIos": "App Store (iPhone)",
  "appLandingTitle": "Comece com a AllDrivers",
  "appLandingRegisterNow": "Registar agora",
  "appLandingManualCode": "Registe-se aqui ou instale a app. Guarde o código para o introduzir no registo: a instalação através da loja não garante que o código seja preservado.",
  "appLandingChecking": "A verificar o código de indicação…",
  "appLandingInvalid": "Este código não está disponível para novas indicações. Pode fazer um registo comum sem indicação.",
  "appLandingUnavailable": "Não foi possível verificar o código agora. Tente novamente ou escolha registar-se sem indicação.",
  "appLandingWithoutWarning": "Se concluir o registo sem indicação, não a poderá adicionar depois.",
  "appLandingWithout": "Registar sem indicação",
  "appLandingMessageAndroid": "Instale a app pelo Google Play. O código de indicação segue com a instalação e fica preenchido quando se registar na app.",
  "appLandingMessageIos": "Instale a app pela App Store. Depois de instalar, volte a esta página e toque em «Já tenho a app — abrir na app» para manter o código de indicação.",
  "appLandingStoresTitle": "Instalar a app",
  "appLandingStoresMessage": "Escolha a loja do seu telemóvel.",
  "appLandingCodeLabel": "O seu código de indicação",
  "appLandingCodeHelp": "Guarde este código. Se a app não o mostrar ao registar-se, volte a esta página e abra a app pelo botão abaixo.",
  "appLandingCopy": "Copiar código",
  "appLandingCopied": "Código copiado.",
  "appLandingCopyFailed": "Não foi possível copiar. Anote o código acima.",
  "appLandingOpenApp": "Já tenho a app — abrir na app",
  "appLandingContinueWeb": "Continuar no navegador"
}
